const WebsiteDisclaimer = () => {
  return (
    <main
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "40px 20px",
        fontFamily: "Arial, sans-serif",
        lineHeight: 1.6,
        color: "#ffffff",
      }}
    >
      <h1>Website & Digital Services Disclaimer</h1>

      <p>
        <strong>Last Updated:</strong> 5/12/2026
      </p>

      <p>
        The information, services, and materials provided through this website
        are for general informational and business purposes only and do not
        constitute legal, financial, marketing, investment, cybersecurity, or
        professional consulting advice.
      </p>

      <h2>No Professional Advice</h2>
      <p>
        Communication with Griffin Managed Web Solutions through this website,
        contact forms, email, phone, or other channels does not create a legal,
        fiduciary, partnership, employment, or agency relationship unless a
        separate written agreement has been executed.
      </p>

      <h2>No Guarantee of Business Results</h2>
      <p>
        We do not guarantee increased revenue, search engine rankings, lead
        generation, conversion rates, website traffic, customer acquisition,
        advertising performance, or specific business outcomes from the use of
        our services, websites, branding, hosting, SEO, automation, or digital
        strategies.
      </p>

      <h2>Project Timelines & Availability</h2>
      <p>
        Estimated delivery dates, timelines, revisions, feature requests, and
        launch schedules are provided in good faith but may vary depending on
        project scope, communication delays, third-party services, hosting
        providers, client feedback, technical limitations, or unforeseen
        circumstances.
      </p>

      <h2>Third-Party Platforms & Services</h2>
      <p>
        Websites and systems developed by Griffin Managed Web Solutions may
        integrate with third-party services including but not limited to hosting
        providers, payment processors, CRMs, analytics tools, email services,
        APIs, social media platforms, cloud infrastructure, and automation
        providers. We are not responsible for outages, policy changes, pricing
        changes, account restrictions, data loss, or disruptions caused by
        third-party providers.
      </p>

      <h2>Client Content Responsibility</h2>
      <p>
        Clients are solely responsible for the legality, ownership, accuracy,
        and licensing of all submitted text, branding, images, videos, logos,
        trademarks, business information, and uploaded content used within their
        website or digital platform.
      </p>

      <h2>Website Availability & Security</h2>
      <p>
        While reasonable efforts may be made to maintain uptime, security, and
        functionality, no website, hosting platform, or online service can be
        guaranteed to be fully uninterrupted, error-free, or immune from cyber
        threats, service outages, software vulnerabilities, or malicious
        activity.
      </p>

      <h2>No Warranty</h2>
      <p>
        All services, software, websites, systems, hosting, branding, and
        related deliverables are provided “as is” and “as available” without
        warranties of any kind, express or implied, including warranties of
        merchantability, fitness for a particular purpose, compatibility,
        availability, or non-infringement.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        To the maximum extent permitted by law, Griffin Managed Web Solutions
        shall not be liable for any indirect, incidental, consequential,
        special, punitive, or financial damages arising from the use of this
        website, our services, downtime, loss of business, loss of data, lost
        profits, advertising performance, cybersecurity incidents, or
        third-party service failures.
      </p>

      <h2>Intellectual Property</h2>
      <p>
        Unless otherwise agreed in writing, all proprietary code, branding
        concepts, animations, systems, graphics, layouts, and digital assets
        created by Griffin Managed Web Solutions remain protected intellectual
        property under applicable copyright and intellectual property laws.
      </p>

      <h2>External Links</h2>
      <p>
        This website may contain links to external websites or services operated
        by third parties. We are not responsible for the availability,
        security, content, policies, or practices of external websites.
      </p>

      <h2>Contact Information</h2>
      <p>
        If you have questions regarding this disclaimer, please contact:
      </p>

      <p>
        <strong>Griffin Managed Web Solutions</strong>
        <br />
        info@griffinmanagedwebsolutions.com
      </p>
    </main>
  );
};

export default WebsiteDisclaimer;
